<div class="overlay" *ngIf="isLoading | async">
	<div class="spinner">
		<div class="spinner-part spinner-part1"></div>
		<div class="spinner-part spinner-part2"></div>
		<img src="/assets/images/motorbike.png" alt="Suzuki Bike" class="spinner-center">
	</div>
</div>

<div class="container-fluid pl-0">
	<div class="container-upload">
		<div class="title">
			<p class="text-left head-text">Reset Password</p>
			<p class="text-left sub-head">Please enter your current password and new password to reset your password
			</p>
		</div>
		<div class="row justify-content-center">
			<div class="col-4 upload-container">
				<form [formGroup]="passwordForm">
					<div class="form-group mt-3">
						<label for="currentPassword">Current Password</label>
						<div class="input-group">
							<input [type]="inputCurrentPass" class="form-control" id="currentPassword" 	[attr.value]="passwordForm.get('currentPassword')?.value"
								formControlName="currentPassword" autocomplete="off" placeholder="Current Password"
								[ngClass]="{ 'is-invalid': submitted && f['currentPassword'].errors }">
							<div class="input-group-append">
								<span class="input-group-text"><i class="bi bi-eye-slash"
										(click)="passwordCurrent('hide')" *ngIf="isHideCurrent"></i>
									<i class="bi bi-eye" (click)="passwordCurrent('show')"
										*ngIf="isShowCurrent"></i></span>
							</div>
							<div *ngIf="submitted && f['currentPassword'].errors" class="invalid-feedback">
								<div *ngIf="f['currentPassword'].errors['required']">
									Current Password is required
								</div>
							</div>
						</div>
					</div>
					<div class="form-group mt-4">
						<label for="newPassword">Enter New Password</label>
						<div class="input-group">
							<input [type]="inputNewPass" class="form-control" id="newPassword" autocomplete="off"
								formControlName="newPassword" placeholder="Password" [attr.value]="passwordForm.get('newPassword')?.value"
								[ngClass]="{ 'is-invalid': submitted && f['newPassword'].errors }">
							<div class="input-group-append">
								<span class="input-group-text"><i class="bi bi-eye-slash" (click)="passwordNew('hide')"
										*ngIf="isHideNew"></i>
									<i class="bi bi-eye" (click)="passwordNew('show')" *ngIf="isShowNew"></i></span>
							</div>
							<div *ngIf="submitted && f['newPassword'].errors" class="invalid-feedback">
								<div *ngIf="f['newPassword'].errors['required']">
									New Password is required
								</div>
								<div *ngIf="f['newPassword'].errors['pattern']">
									Password must be at least 8 characters long, include a number, a special character,
									and a capital letter.
								</div>
							</div>
						</div>
					</div>
					<div class="form-group mt-4">
						<label for="confirmPassword">Confirm New Password</label>
						<div class="input-group">
							<input [type]="inputConfirmPass" class="form-control" id="confirmPassword"
								formControlName="confirmPassword"  [attr.value]="passwordForm.get('confirmPassword')?.value"
								[ngClass]="{ 'is-invalid': submitted && f['confirmPassword'].errors }"
								autocomplete="off" placeholder="Password">
							<div class="input-group-append">
								<span class="input-group-text"><i class="bi bi-eye-slash"
										(click)="passwordConfirm('hide')" *ngIf="isHideConfirm"></i>
									<i class="bi bi-eye" (click)="passwordConfirm('show')"
										*ngIf="isShowConfirm"></i></span>
							</div>
							<div *ngIf="submitted && f['confirmPassword'].errors" class="invalid-feedback">
								<div *ngIf="f['confirmPassword'].errors['required']">
									Confirm Password is required
								</div>
							</div>
						</div>
					</div>
					<button type="submit" class="btn btn-primary btn-block mt-4 mb-4" (click)="setPassword()">Reset
						Password</button>
				</form>
			</div>
		</div>
	</div>
</div>